module.exports = __webpack_public_path__ + "img/block-375.e52190e8.jpg";